module.exports = __webpack_public_path__ + "img/SoftwareCopyright_9.c995731b.png";